const React = require('react');
const map = require('mn-utils/map');

const DataBlock = require('./DataBlock');

module.exports = (props) => {
  const data = props.data || {};
  const headers = data.headers || [];
  const wallets = data.wallets || [];
  const dataArr = [
    {
      title: 'Callback Address',
      value: data.callback_address,
    },
    headers.length && {
      title: 'Headers',
      value: (
        <>
          {headers.map((el, id) => (
            <div key={id}>
              {el[0]}: {el[1]};
            </div>
          ))}
        </>
      ),
    },
    wallets.length && {
      title: 'Wallets',
      value: data.wallets.join(', '),
    },
  ].filter((el) => el);

  return (
    <div className="mb34">
      {map(dataArr, (item, i) => (
        <div key={i} className="w mt21">
          <DataBlock title={item.title} value={item.value} />
        </div>
      ))}
    </div>
  );
};
